/**
 * Текущий язык админки вне React-дерева.
 *
 * Нужен модулю `lib/format.ts`: функции форматирования вызываются напрямую из
 * JSX (не через хук), поэтому язык они читают отсюда. Значение меняет только
 * `LangProvider` — сразу перед setState, поэтому к моменту ререндера дерева
 * форматтеры уже видят новый язык.
 */
export type Lang = 'uz' | 'ru';

export const LANGS: Lang[] = ['uz', 'ru'];

const STORAGE_KEY = 'lms_admin_lang';

/** По умолчанию — узбекский. Русский включается только явным выбором. */
export const DEFAULT_LANG: Lang = 'uz';

function isLang(v: unknown): v is Lang {
  return v === 'uz' || v === 'ru';
}

export function readStoredLang(): Lang {
  if (typeof window === 'undefined') return DEFAULT_LANG;
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return isLang(saved) ? saved : DEFAULT_LANG;
  } catch {
    // приватный режим / отключённое хранилище
    return DEFAULT_LANG;
  }
}

export function storeLang(lang: Lang): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // не критично: язык проживёт до перезагрузки страницы
  }
}

let currentLang: Lang = readStoredLang();

export function getLang(): Lang {
  return currentLang;
}

export function setCurrentLang(lang: Lang): void {
  currentLang = lang;
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lang;
  }
}
